module.exports = __webpack_public_path__ + "img/1559417499.9aa717cb.jpg";